import React from "react";

export const ProductCardSolution = ({
  img,
  title = '',
  content = '',
  path = '/',
  learnMoreText = 'Learn More'
}) => {
  return (
    <article className="product-card-solution">
      <div className="card-image-wrapper">
        <img
          alt={title}
          src={img}
          className="card-image"
        />
      </div>

      <div className="card-content">
        <h3 className="card-title">
          {title}
        </h3>
        <p className="card-description">
          {content}
        </p>
      </div>

      <a href={path} className="card-link">
        <span>{learnMoreText}</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="chevron-icon"
        >
          <path
            d="M7.5 4.16669L13.3333 10L7.5 15.8334"
            stroke="#008CB7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </article>
  );
};